import React, { useRef } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StarIcon from "@mui/icons-material/Star";

const testimonials = [
  {
    name: "Paul",
    title: "My best pick so far",
    review:
      "Warrant present garrets limited cordial in inquiry to. Supported me sweetness behaviour shameless excellent so arranging.",
  },
  {
    name: "Julian Vidal",
    title: "Never this amazed",
    review:
      "Warrant present garrets limited cordial in inquiry to. Supported me sweetness behaviour shameless excellent so arranging.",
  },
  {
    name: "Fabian Vidal",
    title: "Thank you!",
    review:
      "Warrant present garrets limited cordial in inquiry to. Supported me sweetness behaviour shameless excellent so arranging.",
  },
];

const TestimonialsPage = () => {
  const sliderRef = useRef(null);
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendDots: (dots) => (
      <Box
        sx={{
          textAlign: "center",
          bottom: -100,
          "& li.slick-active div:first-of-type": {
            backgroundColor: "#333",
          },
        }}
      >
        <ul style={{ marginTop: "0px", padding: "0px", fontSize: "2rem" }}>
          {" "}
          {dots}{" "}
        </ul>
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={(theme) => ({
          width: "10px",
          height: "10px",
          backgroundColor: "#bbb",
          borderRadius: "50%",
          display: "inline-block",
          margin: "5px",
          transition: "all 0.3s ease",
        })}
      />
    ),
  };

  return (
    <Box>
      <Container maxWidth="lg">
        <Typography variant="h4" textAlign={"center"} sx={styles.title}>
          Trusted by Thousands of{" "}
          <span style={{ color: "#535353" }} className="count-shine">
            {" "}
            Event Organizers{" "}
          </span>
        </Typography>

        <Box sx={{ mt: 8 }}>
          <Slider ref={sliderRef} {...settings}>
            {testimonials.map((testimonial, index) => (
              <Box key={index} sx={{ px: 2 }}>
                <Box
                  sx={{
                    p: 4,
                    textAlign: "left",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    "&:hover": {
                      boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.12)",
                      transform: "translateY(-5px)",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    color="#333"
                    gutterBottom
                  >
                    {testimonial.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {testimonial.review}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      mb: 1,
                    }}
                  >
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} sx={{ color: "#FFA500" }} />
                    ))}
                  </Box>
                  <Typography variant="body2" fontWeight={600} color="#333">
                    {testimonial.name}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsPage;

const styles = {
  title: {
    fontWeight: 700,
    // fontSize: { xs: "2rem", md: "2.5rem" },
    fontSize: { xs: 24, sm: 32, md: 40 },
  },
};
